"use client"
import React from "react";
import CTA from "./CTA"
import CardFlip from "components/CardFlip"

export default function GridValueProp(props) {
    const {title, description, cta, image, reverse} = props

    const contentClass = reverse ? 'features-card-item-invert' : 'features-card-item-alt'

    return (<CardFlip containerClassName={`col-lg-4 col-md-6 col-12`} flipDirection="horizontal">
        <div className={`features-card-item features-card-item-fixed ${contentClass}`}>
            <h3>{title}</h3>
            <p>{description}</p>
        </div>
        <div className={`features-card-item features-card-item-fixed ${contentClass}`}>
            <img src={image.url} alt={image?.alt}/>
            <CTA className="mt-3 pt-3" cta={cta} reverse={reverse} />
        </div>
    </CardFlip>)
}
